import { SyntheticEvent } from 'react'

declare type CapturedEventHandler = (e: SyntheticEvent) => void

/**
 * Convenient shorthand for inline event handlers that should capture the event and stop its propagation.
 * This is a useful for adding click handlers in Primereact overlays that listen to clicks and may close
 *  or launch unwanted behavior when click events nested inside these components fall through.
 *
 * @example `onClick={capture(actualClickHandler)}`
 * @example `onClickCapture={capture(actualClickHandler)}`
 */
export const capture = (handler?: CapturedEventHandler) => (event: SyntheticEvent) => {
    event.stopPropagation()
    if (!handler) return
    return handler(event)
}
